import { PluginType } from '@deephaven/plugin';
import FilterPlugin from "./FilterPlugin.js";
var FilterPluginConfig = {
  name: 'FilterPlugin',
  type: PluginType.DASHBOARD_PLUGIN,
  component: FilterPlugin
};
export default FilterPluginConfig;
//# sourceMappingURL=FilterPluginConfig.js.map